<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11.86,7C11.86,7,15.91,7,15.91,7C15.45,3.39,12.61,0.52,9,0.07C9,0.07,9,4.14,9,4.14C10.4,4.5,11.49,5.6,11.86,7C11.86,7,11.86,7,11.86,7ZM12,8C12,10.21,10.21,12,8,12C5.79,12,4,10.21,4,8C4,5.79,5.79,4,8,4C8,4,8,0,8,0C3.58,0,0,3.58,0,8C0,12.42,3.58,16,8,16C12.42,16,16,12.42,16,8C16,8,12,8,12,8C12,8,12,8,12,8Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'DoughnutChart',
} as DefineComponent
</script>
